module.exports = __webpack_public_path__ + "img/202002.a34152bd.png";